import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Rol } from 'src/app/models/entities/rol';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take, map } from 'rxjs/operators';
import { Funcionalidad } from 'src/app/models/entities/funcionalidad';
import { RolFuncionalidadService } from 'src/app/services/rol-funcionalidad.service';
import { RolFuncionalidad } from 'src/app/models/entities/rol-funcionalidad';
import { LoaderService } from 'src/app/services/loader.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'administrar-perfiles',
  templateUrl: './administrar-perfiles.component.html',
  styleUrls: ['./administrar-perfiles.component.scss']
})
export class AdministrarPerfilesComponent implements OnInit {

  @ViewChild('modalConfirmacion')
  public modalConfirmacion: any;

  public modalActivo: NgbModalRef;

  public catRoles: Rol[] = [];
  public catFuncionalidades: Funcionalidad[] = [];
  public rolSeleccionado: Rol = null;


  public funcionalidadesSeleccionadas: Funcionalidad[] = [];

  public columnasCatalogo = [
    { field: 'key', header: 'Key' },
    { field: 'nombre', header: 'Nombre' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'fechaCreacion', header: 'Fecha creación' },
    { field: 'fechaActualizacion', header: 'Fecha actualización' },
    { field: 'activo', header: 'Estado' }
  ];
  public constructor(
    private ngbModalService: NgbModal,
    private catalogoService: CatalogoService,
    private rolFuncionalidadService: RolFuncionalidadService,
    private loaderService: LoaderService,
    private alertasService: AlertasService
  ) {

  }
  public async ngOnInit(): Promise<void> {
    await this.obtenerCatalogoRoles();
  }

  public async obtenerCatalogoRoles(): Promise<void> {
    this.catRoles = await this.catalogoService.obtenerCatalogo<Rol>(RutaCatalogoEnum.ROLES).pipe(take(1)).toPromise();
    this.catFuncionalidades = await this.catalogoService.obtenerCatalogo<Funcionalidad>(RutaCatalogoEnum.FUNCIONALIDADES).pipe(take(1)).toPromise();
  }

  public async onRowSelect(event: any) {
    this.funcionalidadesSeleccionadas = await this.rolFuncionalidadService.findByKeyRol((event.data as Rol).key).pipe(
      take(1),
      map((rolesFuncionalidades: RolFuncionalidad[]) => {
        return rolesFuncionalidades.map((rolFuncionalidad: RolFuncionalidad) => ({
          ...this.catFuncionalidades.find((funcionalidad: Funcionalidad) => funcionalidad.key === rolFuncionalidad.keyFuncionalidad)
        }) as Funcionalidad)
      })
    ).toPromise();
  }

  public onRowUnselect(event: any) {
  }

  public async guardarCambios(): Promise<void> {
    this.loaderService.activarLoaderScreen();
    await this.eliminarRolesFuncionalidades();
    let fechaActual: Date = new Date();
    for (let i = 0; i < this.funcionalidadesSeleccionadas.length; i++) {
      let rolFuncionalidad: RolFuncionalidad = {
        fechaActualizacion: fechaActual.getTime(),
        fechaCreacion: fechaActual.getTime(),
        keyFuncionalidad: this.funcionalidadesSeleccionadas[i].key,
        keyRol: this.rolSeleccionado.key
      };
      await this.rolFuncionalidadService.save(rolFuncionalidad);
    }
    this.loaderService.desactivarLoaderScreen();
    this.modalActivo.close();
    this.alertasService.mostrarAlerta('success', 'Se han actualizado las funcionalidades del rol con éxito.');
  }

  public async eliminarRolesFuncionalidades(): Promise<void> {
    let rolesFuncionalidades: RolFuncionalidad[] = await this.rolFuncionalidadService.findByKeyRol(this.rolSeleccionado.key).pipe(take(1)).toPromise();
    for (let i = 0; i < rolesFuncionalidades.length; i++) {
      await this.rolFuncionalidadService.remove(rolesFuncionalidades[i].key);
    }
  }

  public abrirModalConfirmacion(): void {
    this.modalActivo = this.ngbModalService.open(this.modalConfirmacion, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

}
